import React, { useCallback } from 'react';
import { FlowBlockPageBreak as BlockModel } from '@staffino/model';
import {
  Box,
  SubmitButton,
  StyledButton,
  buttonFactory,
  TextWrapper,
  convertCssUnit,
  useTheme,
} from '@staffino/primitive-controls';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

const StyledBackButton = StyledButton; // .withComponent('button');
const BackButton =
  buttonFactory<React.ComponentProps<typeof StyledBackButton>>(
    StyledBackButton,
  );

type Props = {
  block: BlockModel;
  onBack?: () => void;
  onClick?: () => void;
};
function PageBreakBlock({ block, onBack, onClick }: Props) {
  const { t } = useTranslation();
  const form = useFormContext();
  const theme = useTheme();
  const { isSubmitting } = form?.formState || {};

  const handleClick = useCallback(
    (event) => {
      // not sure why button click submits the form, we need to prevent that
      event.preventDefault();
      onClick?.();
    },
    [onClick],
  );

  const handleBack = useCallback(
    (event) => {
      // not sure why button click submits the form, we need to prevent that
      event.preventDefault();
      onBack?.();
    },
    [onBack],
  );

  return (
    <>
      {!block.withBackButton && (
        <Box alignItems="center">
          <SubmitButton
            block
            maxWidth={convertCssUnit('30rem')}
            disabled={isSubmitting}
            loading={isSubmitting}
            bg={block.backgroundColor}
            onPress={handleClick}
          >
            <TextWrapper color={theme.colors.actionText}>
              {block.label || t('Continue')}
            </TextWrapper>
          </SubmitButton>
        </Box>
      )}

      {block.withBackButton && (
        <Box
          flexDirection={'row' as const}
          flexWrap="wrap"
          justifyContent="center"
        >
          <Box
            flex="1 0 auto"
            flexDirection={'row' as const}
            flexWrap={['wrap-reverse', 'wrap']}
            justifyContent="center"
          >
            <BackButton
              block
              maxWidth={['', '6rem']}
              disabled={isSubmitting}
              color="#586474"
              bg="transparent"
              activeBg="#d8e1eb"
              mr={[0, '8px']}
              mt={['4px', 0]}
              onPress={handleBack}
            >
              <Trans>Back</Trans>
            </BackButton>
            <SubmitButton
              block
              maxWidth={['', '19rem']}
              disabled={isSubmitting}
              loading={isSubmitting}
              bg={block.backgroundColor}
              onClick={handleClick}
            >
              <TextWrapper>{block.label || t('Continue')}</TextWrapper>
            </SubmitButton>
          </Box>
        </Box>
      )}
    </>
  );
}

export default PageBreakBlock;
